import { Card } from '@mantine/core';
import { TristateBoolean } from '../../../../../react-commons/enums/tristateBoolean';
import { ControlledInputs } from '../../../../../react-commons/utils/read-only-inputs/controlledInputs';
import { getEnumFormatter } from '../../../resource/enumerations/utils/getEnumFormatter';
import { Setting, SettingClass, UpdatedSetting } from '../../../resource/resource-base/settings/types';
import { PropertyValidationInformation } from '../../util/PropertyValidationInformation';
import { Controlled_PropertySystemSettingsSwitchInput } from '../base/property-bases/Controlled_PropertySystemSettingsSwitchInput';
import { ControlledPropertyInputs } from '../base/property-bases/read-only/ControlledPropertyInputs';

export const BasePropertyAdminSettingsComponent= ({ setting, onChange, disabled = false, propertyValidationInformation }: {
    setting: Setting;
    onChange: (setting: UpdatedSetting) => void;
    disabled?: boolean;
    propertyValidationInformation: PropertyValidationInformation;
}) => {
    return (
        <>
            {/* TODO: check nullability everywhere*/}
            {setting.settingDefinition.settingClass === SettingClass.BOOLEAN ?
                <Card style={{ padding: '7px', display: 'flex', flexDirection: 'row' }} withBorder>
                    <Controlled_PropertySystemSettingsSwitchInput
                        propertyValidationInformation={propertyValidationInformation}
                        readOnly={disabled}
                        onChange={(newValue) => {
                            onChange({
                                identifier: setting.settingDefinition.identifier,
                                value: newValue,
                            });
                        }}
                        checked={setting.value as boolean}
                    />
                </Card>
            : setting.settingDefinition.settingClass === SettingClass.STRING ?
                <ControlledPropertyInputs.String
                    readOnly={disabled}
                    value={setting.value as string}
                    nullable={false}
                    onChange={(newValue) =>
                        onChange({
                            identifier: setting.settingDefinition.identifier,
                            value: newValue,
                        })
                    }
                    propertyValidationInformation={propertyValidationInformation}
                />
            : setting.settingDefinition.settingClass === SettingClass.INTEGER ?
                <ControlledPropertyInputs.Number
                    readOnly={disabled}
                    value={setting.value as number}
                    nullable={false}
                    onChange={(newValue) =>
                        onChange({
                            identifier: setting.settingDefinition.identifier,
                            value: newValue,
                        })
                    }
                    propertyValidationInformation={propertyValidationInformation}
                />
                // : setting.settingDefinition.settingClass === SettingClass.ENUM ?
                //     <Card style={{ padding: '7px', display: 'flex', flexDirection: 'column' }} withBorder>
                //         <Stack gap={'xs'}>
                //             <Text fw={'700'}>
                //                 {setting.settingDefinition.identifier
                //                     .split('_')
                //                     .map((word) => word.charAt(0) + word.slice(1).toLowerCase())
                //                     .join(' ')}
                //             </Text>
                //             <ControlledInputs.Enum
                //                 readOnly={disabled}
                //                 value={setting.value as AllowedProjectArchetype}
                //                 enumType={AllowedProjectArchetype}
                //                 enumFormatter={getEnumFormatter(AllowedProjectArchetype)}
                //                 clearable={false}
                //                 onChange={(newValue) =>
                //                     onChange({
                //                         identifier: setting.settingDefinition.identifier,
                //                         value: newValue as AllowedProjectArchetype,
                //                     })
                //                 }
                //             />
                //         </Stack>
                //     </Card>
            :   setting.settingDefinition.settingClass === SettingClass.TRISTATE_BOOLEAN && (
                    <ControlledInputs.Enum
                        label={setting.settingDefinition.identifier
                            .split('_')
                            .map((word) => word.charAt(0) + word.slice(1).toLowerCase())
                            .join(' ')}
                        value={setting.value as TristateBoolean}
                        nullable={false}
                        readOnly={disabled}
                        enumType={TristateBoolean}
                        enumFormatter={getEnumFormatter(TristateBoolean)}
                        onChange={(newValue) =>
                            onChange({
                                identifier: setting.settingDefinition.identifier,
                                value: newValue,
                            })
                        }
                    />
                )
            }
        </>
    );
};
